
export enum CloseAccountStatus {
    Request = 0,
    Confirm = 1,
    Reject = 2
}